<template>
    <div>
        <h1 v-if="!isHeaderPage" class="page-title mb-3 text-2xl">{{ item.title }}</h1>
        <div class="page">
            <Site v-if="isHeaderPage" />
            <Items
                :items="item.items"
                :errors="errors"
                :response-sets="responseSets"
                :show-errors="showErrors"
            />
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import Site from '@/views/ConductInspection/Responses/Site.vue';
    import Items from './Items';

    export default {
        components: { Items, Site },
        props: {
            item: {
                type: Object,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            },
            showErrors: {
                type: Boolean,
                required: true,
            },
            responseSets: {
                type: Array,
                required: true,
            },
        },
        computed: {

            isHeaderPage() {
                return this.item.params && this.item.params.header === true;
            },

        },

        methods: {},
    };

</script>
